// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__tbNYO","title":"Header_title__3lVie","left":"Header_left__jlsLW","clinicName":"Header_clinicName__pmJ7N"};